import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const instance = createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = instance.definePartsStyle({
  field: {
    color: 'textBlack',
    background: 'white',
    focusBorderColor: 'primaryBlack',
    paddingBlock: '8px',
    borderRadius: '8px',
    border: 'solid 1px',
    _focusVisible: {
      outline: 'none',
      borderColor: 'primaryBlack !important',
      boxShadow: 'none',
    },
    _focusWithin: {
      outline: 'none',
      borderColor: 'primaryBlack !important',
      boxShadow: 'none',
    },
    _focus: {
      outline: 'none',
      borderColor: 'primaryBlack !important',
      boxShadow: 'none',
    },
    _active: {
      outline: 'none',
      borderColor: 'primaryBlack !important',
      boxShadow: 'none',
    },
    _hover: {
      outline: 'none',
      borderColor: 'primaryBlack !important',
      boxShadow: 'none',
    },
  },
});

const InputTheme = instance.defineMultiStyleConfig({
  baseStyle,
  sizes: {},
  variants: {
    default: {
      field: {
        borderColor: 'border',
      },
    },
  },
  defaultProps: {
    variant: 'default',
  },
});

export default InputTheme;
